import React, { forwardRef } from 'react'

export default function makeGridComponents(colCount: number, className?: string) {
  const List = forwardRef<HTMLDivElement, any>(function VirtuosoGridList(
    { children, style },
    ref,
  ) {
    const merged: React.CSSProperties = {
      ...(style as React.CSSProperties),
      display: 'grid',
      gridTemplateColumns: `repeat(${colCount}, minmax(10px, 1fr))`,
      columnGap: '16px',
      rowGap: '16px',
      width: '100%',
    }
    return (
      <div ref={ref} style={merged} className={className}>
        {children}
      </div>
    )
  })

  const Item = forwardRef<HTMLDivElement, any>(function VirtuosoGridItem(
    props,
    ref,
  ) {
    return <div ref={ref} {...props} />
  })

  return { List, Item }
}
